<template>
  <main>
    <section class="tp-breadcrumb__area pt-60 pb-60 p-relative z-index-1 fix">
      <div class="tp-breadcrumb__bg" data-background="/assets/lms_website/website-assets/img/breadcrumb/breadcrumb-bg-2.jpg"></div>
      <div class="container">
        <div class="row align-items-center">
          <div class="col-sm-12">
            <div class="tp-breadcrumb__content">
              <div class="tp-breadcrumb__list">
                <span>
                 <router-link :to="{name:'home'}">
                    <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg ">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M8.07207 0C8.19331 0 8.31107 0.0404348 8.40664 0.114882L16.1539 6.14233L15.4847 6.98713L14.5385 6.25079V12.8994C14.538 13.1843 14.4243 13.4574 14.2225 13.6589C14.0206 13.8604 13.747 13.9738 13.4616 13.9743H2.69231C2.40688 13.9737 2.13329 13.8603 1.93146 13.6588C1.72962 13.4573 1.61597 13.1843 1.61539 12.8994V6.2459L0.669148 6.98235L0 6.1376L7.7375 0.114882C7.83308 0.0404348 7.95083 0 8.07207 0ZM8.07694 1.22084L2.69231 5.40777V12.8994H13.4616V5.41341L8.07694 1.22084Z"
                            fill="currentColor"></path>
                    </svg>
                 </router-link>
                </span>
                <span class="color">{{ lms_website.__('Student Applicant') }}</span>
              </div>
              <h3 class="tp-breadcrumb__title white">{{ lms_website.__('Student Applicant') }}</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container py-5">
      <div class="row">
        <div class="layout">
          <div class="card shadow-sm">
            <div class="card-body form-progress mb-4">
              <div class="text-center" v-if="form.is_submitted">
                <CheckMark/>
                <h3 class="text-success mt-3">{{ lms_website.__('Thank You For Submission') }}</h3>
                <p class="text-secondary">{{ lms_website.__('We will review your application and send email if confirmed') }}</p>
              </div>
              <form method="post" v-if="!form.is_submitted" :class="{'form-loading':(form.loading)}" @submit="submitApplicant($event)">
                <div class="info-studant">
                  <div class="section-title" :style="sectionTitleStyle">Student Information - بيانات الطالب</div>
                  <div class="section-container">
                    <div  class="input-container">
                      <label for="custom_application_date" class="form-label"><span>Application Date - تاريخ التسجيل</span> <span class="text-danger">*</span></label>
                      <input type="text" class="form-control form-control-sm readonly-style" v-model="form.data.custom_application_date" readonly id="custom_application_date" placeholder="" required>
                    </div>
                    <div  class="input-container">
                      <label for="first_name" class="form-label"><span>Name in Arabic - الاسم بالعربي </span> <span class="text-danger">*</span></label>
                      <input 
                        type="text" 
                        class="form-control form-control-sm" 
                        :class="{'is-invalid': validationErrors.first_name, 'is-valid': form.data.first_name && !validationErrors.first_name}"
                        v-model="form.data.first_name" 
                        id="first_name" 
                        style="direction:rtl;" 
                        placeholder=""
                        @input="validateArabicName"
                        required
                      >
                      <div class="invalid-feedback" v-if="validationErrors.first_name">
                        {{ validationErrors.first_name }}
                      </div>
                      <div class="valid-feedback" v-else-if="form.data.first_name">
                        {{ lms_website.__('Valid Arabic name') }}
                      </div>
                    </div>
                    <div  class="input-container">
                      <label for="custom_name_in_english" class="form-label"><span>Name in English - الاسم بالانجليزي</span> <span class="text-danger">*</span></label>
                      <input type="text" class="form-control form-control-sm" v-model="form.data.custom_name_in_english" id="custom_name_in_english" placeholder="" required>
                    </div>
                    <div  class="input-container" style="grid-column: 1 / 3; grid-row: 2;">
                      <label for="student_email_id" class="form-label"><span>Student Email Address - البريد الالكتروني </span> <span class="text-danger">*</span></label>
                      <div class="form-control-has-icon">
                        <i class="fal fa-envelope form-control-icon"></i>
                        <input type="email" class="form-control form-control-sm" v-model="form.data.student_email_id" id="student_email_id" placeholder="name@example.com" required>
                      </div>
                    </div>
                    <div class="input-container" style="grid-column: 1 / 3; grid-row: 3;">
                      <label for="custom_other_mobile_number" class="form-label">
                        <span>Other Mobile Number - رقم هاتف آخر</span>
                      </label>
                      <div class="form-control-has-icon">
                        <i class="fal fa-phone-alt form-control-icon"></i>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          :class="{
                            'is-invalid': validationErrors.custom_other_mobile_number,
                            'is-valid': form.data.custom_other_mobile_number && !validationErrors.custom_other_mobile_number
                          }"
                          v-model="form.data.custom_other_mobile_number"
                          id="custom_other_mobile_number"
                          placeholder="01xxxxxxxxx"
                          @input="validateOtherMobile"
                          maxlength="11"
                        >
                      </div>
                      <div class="invalid-feedback" v-if="validationErrors.custom_other_mobile_number">
                        {{ validationErrors.custom_other_mobile_number }}
                      </div>
                      <div class="valid-feedback" v-else-if="form.data.custom_other_mobile_number">
                        {{ lms_website.__('Valid Egyptian mobile number') }}
                      </div>
                    </div>
                    <div  class="input-container">
                      <label for="student_mobile_number" class="form-label"><span>Student Mobile Number - رقم الهاتف </span> <span class="text-danger">*</span></label>
                      <div class="form-control-has-icon">
                        <i class="fal fa-phone-alt form-control-icon"></i>
                        <input 
                          type="text" 
                          class="form-control form-control-sm" 
                          :class="{'is-invalid': validationErrors.student_mobile_number, 'is-valid': form.data.student_mobile_number && !validationErrors.student_mobile_number}"
                          v-model="form.data.student_mobile_number" 
                          id="student_mobile_number" 
                          placeholder="01xxxxxxxxx"
                          @input="validateEgyptianMobile"
                          maxlength="11"
                          required
                        >
                      </div>
                      <div class="invalid-feedback" v-if="validationErrors.student_mobile_number">
                        {{ validationErrors.student_mobile_number }}
                      </div>
                      <div class="valid-feedback" v-else-if="form.data.student_mobile_number">
                        {{ lms_website.__('Valid Egyptian mobile number') }}
                      </div>
                    </div>
                    
                    <div  class="input-container">
                      <label for="custom_national_id" class="form-label"><span>National ID - الرقم القومي </span></label>
                      <input type="text" class="form-control form-control-sm" v-model="form.data.custom_national_id" id="custom_national_id" placeholder="">
                    </div>
                    <div class="input-container">
                      <label for="custom_student_enrollment_code" class="form-label"><span>Student Enrollment Code - كود الالتحاق </span></label>
                      <input type="text" class="form-control form-control-sm" v-model="form.data.custom_student_enrollment_code" id="custom_student_enrollment_code" placeholder="">
                    </div>
                  </div>
                </div>
                <div class="program-info">
                  <div class="section-title" :style="sectionTitleStyle">Program Information - بيانات البرنامج</div>
                  <div class="section-container">
                    <div class="input-container">
                      <label for="custom_study_type" class="form-label"><span>Study Type -  نوع الدراسة</span><span class="text-danger">*</span></label>

                      <!-- Static: the program's Student Admission row defines the study type -->
                      <div v-if="studyTypeReadOnly" class="form-control form-control-sm readonly-style">
                        {{ form.data.custom_study_type }}
                      </div>

                      <!-- Editable: the admission row has no study type set -->
                      <FieldLink
                          v-else
                          :model-value="form.data"
                          :field="form.link_fields.custom_study_type"
                          reference-doctype="Study Type"
                          css-class="form-control-sm"
                          required
                      />
                    </div>
                    <div class="input-container" style="grid-column: 1 / 3; grid-row: 2;">
                      <label for="program" class="form-label">
                        <span>Program - البرنامج </span> 
                        <span class="text-danger">*</span>
                      </label>
                      
                      <!-- Read-only display when program is in URL -->
                      <div v-if="programReadOnly" class="form-control form-control-sm bg-light">
                        {{ form.data.program }}
                      </div>
                      
                      <!-- Editable FieldLink when no program in URL -->
                      <FieldLink
                        v-else
                        :model-value="form.data"
                        :field="form.link_fields.program"
                        reference-doctype="Program"
                        page_length="100"
                        css-class="form-control-sm"
                      />
                    </div>
                    <div class="input-container">
                      <label for="custom_fee_amount" class="form-label"><span>Fee Amount - مبلغ الرسوم </span></label>
                      <input type="text" class="form-control form-control-sm readonly-style" v-model="form.data.custom_fee_amount" id="custom_fee_amount" placeholder="" readonly>
                    </div>
                    <div
                    class="input-container timetable-table-container"
                    :style="{ gridColumn: '1 / 4', gridRow: showWaitingMonth ? 4 : 3 }"
                    v-if="form.data.custom_branch_group_timetable"
                    >
                      <label for="custom_branch_group_timetable_days" class="form-label"><span>Branch Group Timetable Days - المواعيد  </span> <span class="text-danger">*</span></label>
                      <div class="table-rounded-wrapper">
                        <table class="table table-sm bg-white" style="table-layout:fixed">
                          <thead>
                            <tr>
                              <th style="width: 10%;" class="text-center">
                                <input type="checkbox" disabled 
                                  :checked="form.data.custom_branch_group_timetable_days?.length">
                              </th>
                              <th class="text-center">{{ lms_website.__('Day') }}</th>
                              <th class="text-center">{{ lms_website.__('From') }}</th>
                              <th class="text-center">{{ lms_website.__('To') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="!form.data?.custom_branch_group_timetable_days?.length">
                              <td colspan="4" class="text-center text-muted">
                                {{ lms_website.__('No Time Table Days') }}
                              </td>
                            </tr>
                            <tr v-for="row in form.data?.custom_branch_group_timetable_days" :key="row.day">
                              <td class="text-primary text-center">
                                <input type="checkbox" disabled 
                                  :checked="form.data.custom_branch_group_timetable_days?.length">
                              </td>
                              <td class="text-primary text-center">{{ row.day }}</td>
                              <td class="text-primary text-center">{{ row.from_time }}</td>
                              <td class="text-primary text-center">{{ row.to_time }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div 
                    class="input-container courses-table-container"
                    :style="{ gridColumn: '1 / 4', gridRow: showWaitingMonth ? 5 : 4 }"
                    v-if="form.data.program"
                    >
                      <label for="custom_courses" class="form-label"><span>Courses - الدورات</span> <span class="text-danger">*</span></label>
                      <div class="table-rounded-wrapper">
                        <table class="table table-sm bg-white" style="table-layout:fixed">
                          <thead>
                          <tr>
                            <th style="width: 10%;" class="text-center">
                              <input type="checkbox" disabled :checked="form.data.custom_courses?.length">
                            </th>
                            <th style="width: 10%;" class="text-center">{{ lms_website.__('No.') }}</th>
                            <th class="text-center">{{ lms_website.__('Course Name') }}</th>
                            <th style="width: 15%;" class="text-center">{{ lms_website.__('Mandatory') }}</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-if="!form.data?.custom_courses?.length">
                            <td colspan="4" class="text-center">{{ lms_website.__('No Courses To Apply') }}</td>
                          </tr>
                          <tr v-for="row,idx in form.data?.custom_courses">
                            <td class="text-primary text-center">
                              <input type="checkbox" disabled :checked="form.data.custom_courses?.length">
                            </td>
                            <td class="text-primary text-center">{{ idx + 1 }}</td>
                            <td class="text-primary text-center">{{ row.course_name }}</td>
                            <td class="text-primary text-center">
                              <input type="checkbox" disabled :checked="row.required">
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="input-container">
                      <label for="custom_branch" class="form-label"><span>Branch - الفرع </span> <span class="text-danger">*</span></label>

                      <!-- Static: the program's Student Admission row defines the branch -->
                      <div v-if="branchReadOnly" class="form-control form-control-sm readonly-style">
                        {{ form.data.custom_branch }}
                      </div>

                      <!-- Editable: the admission row has no branch set -->
                      <FieldLink
                          v-else
                          :model-value="form.data"
                          :field="form.link_fields.custom_branch"
                          reference-doctype="Cost Center"
                          css-class="form-control-sm"
                      />
                    </div>
                    <div class="input-container" v-if="form.data.custom_branch || branchGroupTimetableReadOnly">
                      <label for="custom_branch_group_timetable" class="form-label"><span>Branch Group Timetable - اختيار الموعد  </span> <span class="text-danger">*</span></label>

                      <!-- Static: the program's Student Admission row defines the timetable -->
                      <div v-if="branchGroupTimetableReadOnly" class="form-control form-control-sm readonly-style">
                        {{ form.data.custom_branch_group_timetable }}
                      </div>

                      <!-- Editable: the admission row has no timetable set -->
                      <FieldLink
                          v-else
                          :model-value="form.data"
                          :field="form.link_fields.custom_branch_group_timetable"
                          reference-doctype="Branch Group Timetable"
                          css-class="form-control-sm"
                      />
                    </div>

                    <!-- Only for waiting groups (Branch Group Timetable.custom_waiting).
                         Pinned directly under the timetable field, above both tables. -->
                    <div class="input-container" style="grid-column: 3; grid-row: 3;" v-if="showWaitingMonth">
                      <label for="custom_waiting_month" class="form-label">
                        <span>Waiting Month - شهر التاجيل</span> <span class="text-danger">*</span>
                      </label>
                      <select
                          class="form-control form-control-sm"
                          :class="{ 'is-invalid': validationErrors.custom_waiting_month }"
                          v-model="form.data.custom_waiting_month"
                          id="custom_waiting_month"
                          :disabled="waitingMonthReadOnly"
                          @change="validateWaitingMonth"
                      >
                        <option value=""></option>
                        <option v-for="month in waitingMonthOptions" :key="month" :value="month">
                          {{ month }}
                        </option>
                      </select>
                      <div class="invalid-feedback" v-if="validationErrors.custom_waiting_month">
                        {{ validationErrors.custom_waiting_month }}
                      </div>
                    </div>

                  </div>
                </div>
                <!-- <div v-if="form.error_message" class="alert alert-danger mb-3" role="alert">
                  {{ form.error_message }}
                </div> -->
                <div class="terms-section">
                  <div class="form-check modern-checkbox">
                  <div>
                    <input 
                      type="checkbox"  
                      class="form-check-input" 
                      id="infoCheckbox"
                      v-model="form.data.terms_accepted"
                      required
                    >
                    <label class="form-check-label" for="infoCheckbox">
                      <span>{{ lms_website.__('أوافق على') }}</span>
                      <a href="#" @click.prevent="openTermsDialog('terms')" class="terms-link">{{ lms_website.__(' الشروط وسياسة الخصوصية') }}</a>
                      <span class="text-danger">*</span>
                    </label>
                  </div>
                    <button 
                      type="submit" 
                      class="btn btn-primary" 
                      :disabled="form.loading || !isFormValid || !form.data.terms_accepted"
                    >
                      {{ lms_website.__('Submit Applicant') }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Terms Dialog -->
    <Transition name="dialog-fade">
      <div v-if="showTermsDialog" class="terms-dialog-overlay" @click.self="closeTermsDialog">
        <div class="terms-dialog">
          <div class="terms-dialog-header">
            <h5 class="terms-dialog-title">
              <i class="fal fa-file-contract me-2"></i>
              {{ dialogTitle }}
            </h5>
            <button type="button" class="terms-dialog-close" @click="closeTermsDialog">
              <i class="fal fa-times"></i>
            </button>
          </div>
          <div class="terms-dialog-body" v-html="termsContent"></div>
          <div class="terms-dialog-footer">
            <button type="button" class="btn btn-secondary btn-sm" @click="closeTermsDialog">
              {{ lms_website.__('Close') }}
            </button>
            <button 
              type="button" 
              class="btn btn-primary btn-sm" 
              @click="acceptAndClose"
              v-if="!form.data.terms_accepted"
            >
              {{ lms_website.__('I Agree') }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </main>
</template>

<script>

import FieldLink from "../../components/forms/fields/FieldLink.vue";
import CheckMark from "../../components/shared/CheckMark.vue";

export default {
  name: "StudentApplicant",
  components: {CheckMark, FieldLink},
  setup() {
    return {
      lms_website
    }
  },
  data() {
    return {
      studyTypeReadOnly: false,
      branchReadOnly: false,
      branchGroupTimetableReadOnly: false,
      waitingMonthReadOnly: false,
      // link_filters of each picker before an admission row restricts it (set in mounted)
      baseLinkFilters: {},
      showWaitingMonth: false,
      // Mirrors the Select options on Student Applicant.custom_waiting_month
      waitingMonthOptions: [
        'يناير', 'فبراير', 'مارس', 'ابريل', 'مايو', 'يونيو',
        'يوليو', 'اغسطس', 'سبتمبر', 'اكتوبر', 'نوفمبر', 'ديسمبر'
      ],
      showTermsDialog: false,
      termsContent: '',
      dialogTitle: '',
      termsLoading: false,
      currentDialogType: '',
      form: {
        loading: false,
        is_submitted: false,
        error_message: '',
        urlParams: {
          student_admission: null,
          program: null,
          academic_year: null
        },
        programReadOnly: false,
        data: {
          custom_fee_amount: 0,
          application_date: moment().format('YYYY-MM-DD'),
          custom_application_date: moment().format('YYYY-MM-DD'),
          // academic_year: moment().format('YYYY'),
          application_status: 'Applied',
          doctype: 'Student Applicant',
          first_name: '',
          student_mobile_number: '',
          custom_other_mobile_number: '',
          custom_waiting_month: ''
        },
        link_fields: {
          custom_branch: {
            name: 'custom_branch',
            doctype: 'Cost Center',
            link_filters: { "name": ["!=", "Online - UA"] },
            required: true
          },
          custom_campaign: {
            name: 'custom_campaign',
            doctype: 'Campaign'
          },
          custom_study_type: {
            name: 'custom_study_type',
            doctype: 'Study Type'
          },
          program: {
            name: 'program',
            doctype: 'Program',
            link_filters: { "custom_enabled": 1 },
            required: true
          },
          custom_branch_group_timetable: {
            name: 'custom_branch_group_timetable',
            doctype: 'Branch Group Timetable',
            link_filters: {"branch": "", "custom_study_type": "", "is_active": 1},
            required: true
          }
        }
      },
      validationErrors: {
        first_name: '',
        student_mobile_number: '',
        custom_other_mobile_number: '',
        custom_waiting_month: ''
      }
    }
  },
  computed: {
    sectionTitleStyle() {
      return {
        backgroundImage: `url('/assets/lms_website/website-assets/img/breadcrumb/breadcrumb-bg-2.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    },
    isFormValid() {
      return !this.validationErrors.first_name &&
        !this.validationErrors.student_mobile_number &&
        !this.validationErrors.custom_other_mobile_number &&
        !this.validationErrors.custom_waiting_month &&
        this.form.data.first_name &&
        this.form.data.student_mobile_number &&
        (!this.showWaitingMonth || this.form.data.custom_waiting_month) &&
        this.form.data.terms_accepted;
    }
  },
  watch: {
    'form.data.custom_branch': function (custom_branch) {
      if (this.form.link_fields.custom_branch) {
        this.form.link_fields.custom_branch_group_timetable.link_filters['branch'] = custom_branch;
      }
    },
    'form.data.custom_study_type': function (custom_study_type) {
      if (this.form.link_fields.custom_study_type) {
        this.form.link_fields.custom_branch_group_timetable.link_filters['custom_study_type'] = custom_study_type;
      }
    },
    'form.data.custom_branch_group_timetable': function (branch_group_timetable) {
      if (branch_group_timetable) {
        frappe.call({
          type: 'POST',
          method: "lms_website.api.client.get",
          args: {
            doctype: 'Branch Group Timetable',
            name: branch_group_timetable
          },
          callback: ({message}) => {
            setTimeout(() => {
              this.form.data.custom_timetable_group_number = message.group_number;
              this.form.data.custom_branch_group_timetable_days = message.branch_group_timetable_days;
            }, 10);

            // Waiting groups require the applicant to pick a waiting month
            this.showWaitingMonth = !!message.custom_waiting;
            if (!this.showWaitingMonth) {
              this.form.data.custom_waiting_month = '';
              this.validationErrors.custom_waiting_month = '';
            }
          }
        });
      } else {
        this.showWaitingMonth = false;
        this.form.data.custom_waiting_month = '';
        this.validationErrors.custom_waiting_month = '';
      }
    },
    'form.data.program': function (program) {
      if (program){
        frappe.call({
          type: 'GET',
          method: "lms_website.api.utils.get_admission_program_defaults",
          args: {
            program: program,
            student_admission: this.getUrlParams().student_admission || ''
          },
          callback: ({message}) => {
            const allowed = message || {};

            // Per field: none allowed -> free choice, one -> static,
            // several -> the applicant picks among them.
            this.applyAllowedValues('custom_study_type', allowed.custom_study_type, 'studyTypeReadOnly');
            this.applyAllowedValues('custom_branch', allowed.custom_branch, 'branchReadOnly');
            this.applyAllowedValues('custom_branch_group_timetable', allowed.custom_branch_group_timetable, 'branchGroupTimetableReadOnly');

            // Waiting month is a single value: prefill and lock it when the program sets one
            if (allowed.custom_waiting_month && this.programReadOnly) {
              this.form.data.custom_waiting_month = allowed.custom_waiting_month;
              this.waitingMonthReadOnly = true;
            } else {
              this.waitingMonthReadOnly = false;
            }
          }
        })
        frappe.call({
          type: 'GET',
          method: "lms_website.api.utils.get_fee_amount_for_program",
          args: {
            program: program
          },
          callback: ({message}) => {
            console.log('==fee amount==', message);
            this.form.data.custom_fee_amount = message;
          }
        })
        frappe.call({
          type: 'GET',
          method: "lms_website.api.utils.get_courses_for_program",
          args: {
            program: program
          },
          callback: ({message}) => {
            console.log('==courses==', message);
            this.form.data.custom_courses = message;
          }
        })
      } else {
        // No program selected -> nothing dictates these fields
        this.applyAllowedValues('custom_study_type', [], 'studyTypeReadOnly');
        this.applyAllowedValues('custom_branch', [], 'branchReadOnly');
        this.applyAllowedValues('custom_branch_group_timetable', [], 'branchGroupTimetableReadOnly');
        this.waitingMonthReadOnly = false;
      }
    },
  },
  methods: {
    applyAllowedValues(fieldname, allowed, readOnlyKey) {
      const values = allowed || [];
      const link_field = this.form.link_fields[fieldname];
      const base = this.baseLinkFilters[fieldname];

      // Start from the field's original ("old") filters.
      const filters = base ? { ...base } : {};

      // The timetable also carries dynamic branch / study-type filters that the
      // watchers manage - re-apply them here (branch & study type are resolved
      // before the timetable in the callback) so restricting to the program's
      // allowed set does not wipe the old filters.
      if (fieldname === 'custom_branch_group_timetable') {
        filters.branch = this.form.data.custom_branch || '';
        filters.custom_study_type = this.form.data.custom_study_type || '';
      }

      // Restrict to the program's set only when the program is locked; if the
      // applicant can change the program, drop the restriction (keep base/old filters).
      if (values.length > 1 && this.programReadOnly) {
        filters.name = ["in", values];
      }

      link_field.link_filters = Object.keys(filters).length ? filters : undefined;
      // Apply the program's default (and lock) only when the program itself is
      // locked; if the applicant can change the program, leave these fields empty.
      this.form.data[fieldname] = (this.programReadOnly && values.length === 1) ? values[0] : '';
      this[readOnlyKey] = this.programReadOnly && values.length === 1;
    },
    validateWaitingMonth() {
      // Mandatory only while the selected timetable is a waiting group
      if (this.showWaitingMonth && !this.form.data.custom_waiting_month) {
        this.validationErrors.custom_waiting_month =
          this.lms_website.__('Please select a waiting month');
      } else {
        this.validationErrors.custom_waiting_month = '';
      }
    },
    validateOtherMobile() {
      // Optional field: may still be unset when the form is submitted untouched
      let value = this.form.data.custom_other_mobile_number || '';

      // Remove non-digit characters
      value = value.replace(/\D/g, '');

      // Ensure starts with 0
      if (value.length > 0 && !value.startsWith('0')) {
        value = '0' + value;
      }

      // Limit to 11 digits
      if (value.length > 11) {
        value = value.slice(0, 11);
      }

      this.form.data.custom_other_mobile_number = value;

      const egyptMobileRegex = /^(010|011|012|015)\d{8}$/;

      // Field is optional — clear error if empty
      if (!value) {
        this.validationErrors.custom_other_mobile_number = '';
        return;
      }

      if (value.length < 11) {
        this.validationErrors.custom_other_mobile_number =
          this.lms_website.__('Mobile number must be 11 digits');
      } else if (!egyptMobileRegex.test(value)) {
        this.validationErrors.custom_other_mobile_number =
          this.lms_website.__('Please enter a valid Egyptian mobile number (starts with 010, 011, 012, or 015)');
      } else {
        this.validationErrors.custom_other_mobile_number = '';
      }
    },
    openTermsDialog(type) {
      this.currentDialogType = type;
      this.dialogTitle = type === 'terms' 
        ? this.lms_website.__('Terms and Conditions') 
        : this.lms_website.__('Privacy Policy');
      this.showTermsDialog = true;
      this.fetchTermsContent(type);
    },
    
    closeTermsDialog() {
      this.showTermsDialog = false;
      this.termsContent = '';
    },
    
    acceptAndClose() {
      this.form.data.terms_accepted = true;
      this.closeTermsDialog();
    },
        
    fetchTermsContent(type) {
      this.termsLoading = true;
      
      frappe.call({
        type: 'POST',
        method: "lms_website.api.user.get_terms_content",
        callback: (r) => {
          console.log('Response:', r);
          
          // Handle different response structures
          if (r.message) {
            if (r.message.rules) {
              this.termsContent = r.message.rules.rules;
            } else {
              this.termsContent = '<p>No rules content found</p>';
            }
          } else {
            this.termsContent = '<p>Unable to load content</p>';
          }
          
          this.termsLoading = false;
        },
        error: (err) => {
          console.error('Fetch error:', err);
          this.termsContent = '<p class="text-danger">Error loading content. Please try again.</p>';
          this.termsLoading = false;
        }
      });
    },
    getUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);
      return {
        student_admission: urlParams.get('student_admission'),
        program: urlParams.get('program'),
        academic_year: urlParams.get('academic_year')
      };
    },
    validateArabicName() {
      const value = this.form.data.first_name || '';
      // Arabic letters, spaces, and Arabic-specific characters (taa marbuta, alef variants, etc.)
      const arabicRegex = /^[\u0600-\u06FF\s]+$/;
      
      if (!value) {
        this.validationErrors.first_name = '';
        return;
      }
      
      if (!arabicRegex.test(value)) {
        this.validationErrors.first_name = this.lms_website.__('Please enter Arabic letters only');
        // Optional: Filter out non-Arabic characters in real-time
        this.form.data.first_name = value.replace(/[^\u0600-\u06FF\s]/g, '');
      } else {
        this.validationErrors.first_name = '';
      }
    },
    
    validateEgyptianMobile() {
      let value = this.form.data.student_mobile_number || '';

      // Remove any non-digit characters
      value = value.replace(/\D/g, '');
      
      // Ensure it starts with 0
      if (value.length > 0 && !value.startsWith('0')) {
        value = '0' + value;
      }
      
      // Limit to 11 digits
      if (value.length > 11) {
        value = value.slice(0, 11);
      }
      
      this.form.data.student_mobile_number = value;
      
      // Validation regex for Egyptian mobile numbers
      // Accepts: 010, 011, 012, 015 followed by 8 digits
      const egyptMobileRegex = /^(010|011|012|015)\d{8}$/;
      
      if (!value) {
        this.validationErrors.student_mobile_number = '';
        return;
      }
      
      if (value.length < 11) {
        this.validationErrors.student_mobile_number = this.lms_website.__('Mobile number must be 11 digits');
      } else if (!egyptMobileRegex.test(value)) {
        this.validationErrors.student_mobile_number = this.lms_website.__('Please enter a valid Egyptian mobile number (starts with 010, 011, 012, or 015)');
      } else {
        this.validationErrors.student_mobile_number = '';
      }
    },
    
    submitApplicant($event) {
      $event.preventDefault();
      
      // Clear previous errors
      this.form.error_message = '';
      
      // Final validation check before submission
      this.validateArabicName();
      this.validateEgyptianMobile();
      this.validateOtherMobile();
      this.validateWaitingMonth();

      if (!this.isFormValid) {
        this.$toast.error(this.lms_website.__('Please correct the validation errors before submitting'));
        return;
      }
      
      this.form.loading = true;
      frappe.call({
        type: 'POST',
        method: "lms_website.api.utils.create_doc",
        args: {
          doctype: this.form.data.doctype,
          frm_data: this.form.data
        },
        callback: ({message}) => {
          this.$toast.success(lms_website.__("Your application has been submitted"));
          this.form.is_submitted = true;
        },
        error: (err) => {
          this.form.loading = false;
          // Handle error message from server
          let errorMsg = '';
          if (err._server_messages) {
            const messages = JSON.parse(err._server_messages);
            errorMsg = messages.join(', ');
          } else if (err.message) {
            errorMsg = err.message;
          } else if (err.exc) {
            errorMsg = err.exc;
          } else {
            errorMsg = this.lms_website.__('An error occurred while submitting your application. Please try again.');
          }
          this.form.error_message = errorMsg;
          this.$toast.error(errorMsg);
        },
        always: (response) => {
          this.form.loading = false;
          console.log('==response==', response._server_messages);
          if (response.exception && !response._server_messages) {
            const errorMsg = this.lms_website.__(response._server_messages);
            this.form.error_message = errorMsg;
            frappe.msgprint({
              title: this.lms_website.__("Error"),
              message: errorMsg,
              indicator: "red",
            });
          }
        }
      });
    }
  },
  mounted() {
    this.baseLinkFilters = Object.fromEntries(
      Object.entries(this.form.link_fields).map(([name, f]) => [name, f.link_filters && { ...f.link_filters }])
    );

    // Get URL parameters
    this.urlParams = this.getUrlParams();
    
    // If program exists in URL, set it and make readonly
    if (this.urlParams.program) {
      this.programReadOnly = true;
      // Set the program value in your form data
      this.$nextTick(() => {
        this.form.data.program = decodeURIComponent(this.urlParams.program);
      });
    }
    setTimeout(() => {
      NProgress.done();
      $("[data-background]").each(function () {
        $(this).css("background-image", "url( " + $(this).attr("data-background") + "  )");
      });
    }, 500);
  }
}
</script>

<style lang="scss" scoped>
.readonly-style{
  background-color: #e9ecef;
  opacity: 1;
  user-select: none;
  cursor: not-allowed;
}
.card {
  font-family: 'Alexandria', serif;

  .card-body{
    padding: 0px;
    .info-studant{
      .section-title{
        border-radius: 5px 5px 0px 0px;
        padding: 10px;
        font-size: 16px;
        color: rgb(0, 0, 0);
        font-weight: bold;
      }
      .section-container{
        position: relative;
        padding: 10px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
        grid-auto-rows: minmax(100px, auto);
        .input-container{
          height: fit-content;
          padding: 0;
          margin: 0;

          .form-label {
            color: #4f5e82;
            font-size: 12px;
          }
        }
      }
    }
    .program-info{
      margin-bottom: 15px;
      .section-title{
        padding: 10px;
        font-size: 16px;
        color: rgb(0, 0, 0);
        font-weight: bold;
      }
      .section-container{
        position: relative;
        padding: 10px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
        grid-auto-rows: minmax(100px, auto);
        &::before {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 96%;
          height: 2px;
          transform: translateX(-50%);
          border-radius: 50%;
          background-image: linear-gradient(to right, black, #5169f1, black);
        }

        .input-container{
          height: fit-content;
          padding: 0;
          margin: 0;

          .form-label {
            color: #4f5e82;
            font-size: 12px;
          }
        }
      }
    }
    .btn-section{
      display: flex;
      justify-content: flex-end;
      padding: 10px;
      button{
        font-family: 'Alexandria', serif;
        border-radius: 50px;
      }
    }
  }
}
.row{
  width: 100%;
  .container{
    display: flex;
    align-items: center;
    justify-content: center;
    .layout {
      width: 100%;
      background-color: transparent;
    }
  }
}
.table-rounded-wrapper {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #dee2e6;

  table {
    margin-bottom: 0;
    border-collapse: separate;    
    border-spacing: 0;        

    thead {
      background-color: #f8f9fa;
      
      tr th {
        border-bottom: 1px solid #dee2e6;
        border-right: 1px solid #dee2e6;
        border-top: none;
        vertical-align: middle;
        font-size: 14px;

        &:first-child {
          border-left: none;    
        }
        &:last-child {
          border-right: none;  
        }
      }
    }

    tbody {
      tr {
        td {
          border-top: 1px solid #dee2e6;
          border-right: 1px solid #dee2e6;
          border-bottom: none;   
          &:first-child {
            border-left: none;    
          }
          &:last-child {
            border-right: none;  
          }
        }
        &:first-child td {
          border-top: none;
        }
      }
    }
  }
}

// Validation styles
.is-invalid {
  border-color: #dc3545 !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.is-valid {
  border-color: #198754 !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.valid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #198754;
}

// RTL support for validation icons
[dir="rtl"] .is-invalid,
[dir="rtl"] .is-valid,
[style*="direction:rtl"] .is-invalid,
[style*="direction:rtl"] .is-valid {
  background-position: left calc(0.375em + 0.1875rem) center;
}
// ========================
// RESPONSIVE - Mobile First
// ========================
/* Modern Terms Section */
.terms-section {
  padding: 20px;
  border-radius: 12px;
  margin: 20px 0;
}

.modern-checkbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0;
  
  .form-check-input {
    width: 22px;
    height: 22px;
    margin-top: 2px;
    border: 2px solid #5169f1;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:checked {
      background-color: #5169f1;
      border-color: #5169f1;
      box-shadow: 0 0 0 3px rgba(81, 105, 241, 0.2);
    }
    
    &:focus {
      box-shadow: 0 0 0 4px rgba(81, 105, 241, 0.3);
    }
  }
  
  .form-check-label {
    font-size: 14px;
    line-height: 1.6;
    color: #4f5e82;
    cursor: pointer;
    
    .terms-link {
      color: #5169f1;
      text-decoration: none;
      font-weight: 600;
      position: relative;
      padding: 0 2px;
      
      &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 0;
        height: 2px;
        background: linear-gradient(90deg, #5169f1, #8b5cf6);
        transition: width 0.3s ease;
      }
      
      &:hover::after {
        width: 100%;
      }
      
      &:hover {
        color: #8b5cf6;
      }
    }
  }
}

/* Dialog Styles */
.terms-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.terms-dialog {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 700px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: dialogSlideIn 0.3s ease;
}

@keyframes dialogSlideIn {
  from {
    opacity: 0;
    transform: translateY(-30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.terms-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 16px 16px 0 0;
  
  .terms-dialog-title {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #1f2937;
    display: flex;
    align-items: center;
    
    i {
      color: #5169f1;
    }
  }
  
  .terms-dialog-close {
    background: none;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #6b7280;
    transition: all 0.2s ease;
    
    &:hover {
      background: #f3f4f6;
      color: #1f2937;
      transform: rotate(90deg);
    }
  }
}

.terms-dialog-body {
  padding: 24px;
  overflow-y: auto;
  max-height: 50vh;
  line-height: 1.8;
  color: #374151;
  font-size: 14px;
  
  h1, h2, h3 {
    color: #1f2937;
    margin-top: 0;
  }
  
  p {
    margin-bottom: 16px;
  }
  
  ul, ol {
    padding-left: 20px;
    margin-bottom: 16px;
  }
}

.terms-dialog-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
  border-radius: 0 0 16px 16px;
  
  .btn {
    padding: 10px 24px;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.2s ease;
    
    &.btn-primary {
      background: linear-gradient(135deg, #5169f1 0%, #8b5cf6 100%);
      border: none;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 20px -5px rgba(81, 105, 241, 0.4);
      }
    }
    
    &.btn-secondary {
      background: white;
      border: 1px solid #d1d5db;
      color: #374151;
      
      &:hover {
        background: #f3f4f6;
      }
    }
  }
}

/* Transition Animation */
.dialog-fade-enter-active,
.dialog-fade-leave-active {
  transition: opacity 0.3s ease;
}

.dialog-fade-enter-from,
.dialog-fade-leave-to {
  opacity: 0;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .terms-section {
    padding: 15px;
  }
  
  .modern-checkbox {
    .form-check-input {
      width: 20px;
      height: 20px;
    }
    
    .form-check-label {
      font-size: 13px;
    }
  }
  
  .terms-dialog {
    max-height: 90vh;
    margin: 10px;
  }
  
  .terms-dialog-body {
    padding: 16px;
    max-height: 60vh;
  }
  
  .terms-dialog-footer {
    flex-direction: column-reverse;
    
    .btn {
      width: 100%;
      justify-content: center;
    }
  }
}
@media (max-width: 768px) {
  .container{
    display: flex;
    align-items: center;
    justify-content: center;
    .card {
      .card-body {
        .info-studant,
        .program-info {
          .section-title {
            font-size: 14px;
            padding: 8px 10px;
          }
  
          .section-container {
            grid-template-columns: 1fr !important;  // One field per line
            grid-auto-rows: auto !important;
            gap: 12px;
            padding: 12px;
  
            // Override ALL inline grid placements
            .input-container {
              grid-column: 1 / 3 !important;
              grid-row: auto !important;
              width: 100%;
  
              .form-label {
                font-size: 11px;
                margin-bottom: 4px;
                display: block;
              }
  
              .form-control {
                width: 100%;
                font-size: 13px;
              }
  
              // Fix icon input on mobile
              .form-control-has-icon {
                width: 100%;
                .form-control {
                  width: 100%;
                }
              }
            }
          }
          // ✅ Push courses table to the bottom on mobile
          .courses-table-container {
            order: 100 !important;
            grid-column: 1 / -1 !important;
            grid-row: auto !important;
          }

          // ✅ Push timetable table just before courses
          .timetable-table-container {
            order: 99 !important;
            grid-column: 1 / -1 !important;
            grid-row: auto !important;
          }
        }
  
        .btn-section {
          padding: 12px;
          button {
            width: 100%;
            border-radius: 50px;
            font-size: 14px;
            padding: 10px;
          }
        }
      }
    }
  }
  
  // Tables scroll on mobile
  .table-rounded-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    table {
      min-width: 100%;

      thead tr th,
      tbody tr td {
        font-size: 11px;
        padding: 5px 6px;
        white-space: nowrap;
        overflow: scroll;
      }
    }
  }
  // .program-info .section-container {
  //   .input-container {
  //     grid-column: 1 / -1 !important;
  //     grid-row: auto !important;
  //   }
    
  //   // Define exact mobile order
  //   .input-container:nth-child(1) { order: 1; }  // Study Type
  //   .input-container:nth-child(2) { order: 2; }  // Program
  //   .input-container:nth-child(3) { order: 3; }  // Fee Amount
  //   .input-container:nth-child(4) { order: 8; }  // Timetable days
  //   .input-container:nth-child(5) { order: 7; }  // Courses ← or move to 7
  //   .input-container:nth-child(6) { order: 4; }  // Branch
  //   .input-container:nth-child(7) { order: 5; }  // Branch Group Timetable
    
  //   // Move courses AFTER branch fields
  //   .courses-table-container {
  //     order: 9 !important;
  //   }
  // }
  // Breadcrumb
  .tp-breadcrumb__title {
    font-size: 20px !important;
  }

  // Container padding
  .container {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .py-5 {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
}
</style>